import { render, staticRenderFns } from "./IconSidebar.vue?vue&type=template&id=d0bb6506&"
import script from "./IconSidebar.vue?vue&type=script&lang=js&"
export * from "./IconSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports